import { useEffect } from 'react';
import { useAuthStore } from '../stores/authStore';

export const usePermissions = () => {
  const { refreshUserPermissions } = useAuthStore();

  useEffect(() => {
    const handlePermissionsUpdate = () => {refreshUserPermissions();
    };

    window.addEventListener('permissions_updated', handlePermissionsUpdate);

    return () => {
      window.removeEventListener('permissions_updated', handlePermissionsUpdate);
    };
  }, [refreshUserPermissions]);
}; 